/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */
import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  // someThing: () => _t(translations.someThing,'default value'),

  name2: () => _t(translations.TrackYourNetWorth.name),
  day: () => _t(translations.TrackYourNetWorth.day),
  week: () => _t(translations.TrackYourNetWorth.week),
  month: () => _t(translations.TrackYourNetWorth.month),
  year: () => _t(translations.TrackYourNetWorth.year),
  error2: () => _t(translations.TrackYourNetWorth.error),
  name3: () => _t(translations.ViewAssets.name),
  goals: () => _t(translations.ViewAssets.goals),
  platforms: () => _t(translations.ViewAssets.platforms),
  assetType: () => _t(translations.ViewAssets.assetType),
  errorAccount: () => _t(translations.ViewAssets.errorAccount),
  errorAsset: () => _t(translations.ViewAssets.errorAsset),
  addAsset: () => _t(translations.ViewAssets.addAsset),
  name4: () => _t(translations.AssetDistribution.name),
  diverse: () => _t(translations.AssetDistribution.diverse),
  assets: () => _t(translations.AssetDistribution.assets),
  name5: () => _t(translations.analysisSuggestion.name),
  choose: () => _t(translations.analysisSuggestion.choose),
  stocks: () => _t(translations.analysisSuggestion.stocks),
};
